<template>
    <div>
        <b-form-input
            v-model="searchQuery"
            placeholder="Search for a user or leave empty for anonymous..."
            @input="fetchUsers"
        ></b-form-input>
        <b-dropdown v-if="filteredUserOptions.length > 0" ref="dropdown" text="Select User" variant="info" class="mt-2">
            <b-dropdown-item
                v-for="option in filteredUserOptions"
                :key="option.value"
                @click="selectUser(option.value, option.text)"
            >
                {{ option.text }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="selectUser(null)">Anonymous</b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: 'UserAutocomplete',
    data() {
        return {
            searchQuery: '',
            users: [],
            selectedUserId: null,
        };
    },
    computed: {
        filteredUserOptions() {
            return this.users.map(user => ({
                value: user.id,
                text: `${user.name} (${user.email})`
            }));
        }
    },
    methods: {
        fetchUsers() {
            if (this.searchQuery.length >= 2) {
                // Replace with your actual API call
                this.$http.get(`/users/autocomplete?query=${this.searchQuery}`)
                    .then(response => {
                        this.users = Object.entries(response.data).map(([key, value]) => ({
                            id: value,
                            name: key.split(' (')[0],
                            email: key.match(/\(([^)]+)\)/)[1],
                        }));
                    })
                    .catch(error => console.error('Error fetching users:', error));
            }
        },
        selectUser(userId, userName) {
            this.selectedUserId = userId;
            // If you want to display the selected userName in the input field:
            this.searchQuery = userId ? userName : '';
            this.$emit('input', userId); // Emitting the selected user ID to the parent component
        },
    },
    watch: {
        selectedUserId(newVal) {
            if (newVal === null) {
                // Reset searchQuery if Anonymous is selected
                this.searchQuery = '';
            }
        }
    }
};
</script>
